import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListitemBuilder } from '../../../../shared/dropdown-list/ListItemBuilder';
import { RetornoSelecao } from '../../../../shared/gridview/RetornoSelecao';
import { Estado } from '../../../../shared/shared/estado.enum';

declare var $: any;

@Component({
  selector: 'app-analise-estoque-bi04',
  templateUrl: './analise-estoque-bi04.component.html',
  styleUrls: ['./analise-estoque-bi04.component.css']
})
export class AnaliseEstoqueBi04Component implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;
  filtros = {};

  parametrosFiltro: any;

  ano: any;
  mes_inicial: any;
  mes_final: any;

  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  anoDropDown = {};

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['ano'], params['mes_inicial'], params['mes_final']);
      this.carregarFiltrosParametros();
    });
  }

  ngOnInit() {
    this.carregarAno();
    this.geraAnoDropDown();
    this.carregarMesInicial();
    this.carregarMesFinal();
  }

  setaValorData(ano: any, mes_inicial: any, mes_final: any) {
    if (ano === undefined || ano === null) {
      this.ano = this.anoAtual.getFullYear();
    }

    if (mes_inicial === undefined || mes_inicial === null) {
      this.mes_inicial = 1;
    }

    if (mes_final === undefined || mes_final === null) {
      this.mes_final = 12;
    }
    this.filtros = { ano: this.ano, mes_inicial: this.mes_inicial, mes_final: this.mes_final };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#analise-estoque-bi04-filtro').modal();
  }

  private carregarAno() {
    this.ano =
      new ListitemBuilder()
        .add(1, this.anoRetrasado.getFullYear() - 2)
        .add(2, this.anoAnterior.getFullYear() - 1)
        .add(3, this.anoAtual.getFullYear())
        .build();
  }

  private geraAnoDropDown() {
    this.anoDropDown = [
      {"value": this.anoRetrasado.getFullYear() - 2},
      {"value": this.anoAnterior.getFullYear() - 1},
      {"value": this.anoAtual.getFullYear()}
    ]
  }

  private carregarMesInicial() {
    this.mes_inicial =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  private carregarMesFinal() {
    this.mes_final =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

}
